import React from "react";
import { Link } from "react-router-dom";
import topicsBackground from "../assets/images/topics_background.svg";
import TermsContent from "../components/legal/TermsContent";

const TermsOfServicePage: React.FC = () => {
  return (
    <div className="min-h-screen relative pb-6 bg-gradient-to-b from-electrum-100 via-white to-white">
      {/* Fixed Background Image */}
      <div
        className="fixed inset-0 z-0 top-8"
        style={{
          backgroundImage: `url(${topicsBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center top",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
        }}
      />
      <div className="relative max-w-5xl mx-auto px-8 py-8 my-10 bg-white shadow-lg rounded-lg">
        <h1 className="text-3xl font-bold mb-2 text-gray-900">
          Terms of Service
        </h1>
        <TermsContent showLastUpdated={true} />
        <div className="mt-8 pt-6 border-t border-gray-200">
          <Link
            to="/legal"
            className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium"
          >
            ← Back to Legal and Privacy Policy
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
